// Bluetooth signal strength as words. RSSI is in dBm; closer is higher.
export function signalLabel(rssi) {

  const value = parseInt(rssi, 10);

  if (isNaN(value)) {
    return '';
  }

  if (value >= -60) {
    return 'Strong signal';
  }

  if (value >= -75) {
    return 'Good signal';
  }

  return 'Weak signal';

}

// 0..3 bars, for a compact indicator.
export function signalBars(rssi) {

  const value = parseInt(rssi, 10);

  if (isNaN(value)) {
    return 0;
  }

  if (value >= -60) {
    return 3;
  }

  if (value >= -75) {
    return 2;
  }

  return 1;

}
